import React, { FC } from 'react';
import { useSelector } from 'react-redux';

import Thumbnail from '../../../filmstrip/components/web/Thumbnail';

export interface ListVideoProps {
    onChange: () => void;
}
const ListVideo: FC<ListVideoProps> = ({ onChange }) => {
    const goPrev = () => {
        const elmnt = document.getElementById('listVideo');

        elmnt.scrollTop -= 140;
    };
    const goNext = () => {
        const elmnt = document.getElementById('listVideo');

        elmnt.scrollTop += 140;
    };
    const tracks = useSelector(state => state['features/base/tracks']);

    return (
        <div className = 'o-list-video'>
            <div className = 'o-list-video-wrapper'>
                <button
                    className = 'o-list-video-btn-prev'
                    onClick = { goPrev }>
                    <img
                        src = '../../../../../images/btn-top.svg'
                        width = '16'
                        height = '10' />
                </button>
                <div
                    className = 'o-list-video-thumnail'
                    id = 'listVideo'>
                    { tracks && tracks.map(track =>
                            track.videoType === 'desktop' && <div className = 'o-list-video-thumnail-item' >
                                <Thumbnail
                                    disableTint = { true }
                                    isShareScreen = { true }
                                    key = { track.participantId }
                                    participantID = { track.participantId } />
                            </div>
                    )}
                </div>
                <button
                    className = 'o-list-video-btn-next'
                    onClick = { goNext }>
                    <img
                        src = '../../../../../images/btn-bottom.svg'
                        width = '16'
                        height = '10' />
                </button>
            </div>
            <button
                className = 'o-list-video-btn-add'
                onClick = { onChange }>
                <img
                    src = '../../../../../images/icon-add-video.svg'
                    width = '24'
                    height = '24' />
            </button>
        </div>
    );
};

ListVideo.defaultProps = {
    onChange: () => { }
};
export default ListVideo;
